import { useCallback } from "react";

import {
  createFileRoute,
  redirect,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { Route as OrderDetailsRoute } from "@app/navigation/routes/_private/orders/$id.tsx";
import { ExchangeOrderPageConnector } from "@pages/exchange-order/exchange-order-page-connector";
import { FeatureFlag } from "@shared/feature-toggle/default-flags.ts";

export const Route = createFileRoute("/_private/exchange")({
  beforeLoad: ({ context }) => {
    if (!context.hasFeatureFlag(FeatureFlag.FT_EXCHANGE_FLOW)) {
      throw redirect({ to: "/" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const navigate = useNavigate();

  const handleGoToOrderDetails = useCallback(
    async (id: string) => {
      await navigate({
        params: { id },
        to: OrderDetailsRoute.fullPath,
      });
    },
    [navigate],
  );

  return (
    <ExchangeOrderPageConnector
      onGoBack={router.history.back}
      onGoOrder={handleGoToOrderDetails}
    />
  );
}
